exports = module.exports = require("../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".contacts-title[data-v-9d6a9dda]{border-bottom:3px solid #eeeff2;padding-bottom:20px}.contacts-icon[data-v-9d6a9dda]{font-size:2rem}.message-input[data-v-9d6a9dda]{width:100%;border-radius:12px;padding:5px;background-color:#eeeff2}iframe[data-v-9d6a9dda]{color:grey}#map[data-v-9d6a9dda]{-webkit-filter:grayscale(90%);-moz-filter:grayscale(90%);-ms-filter:grayscale(90%);-o-filter:grayscale(90%);filter:grayscale(90%)}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?minimize!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-9d6a9dda","scoped":true,"hasInlineConfig":false}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/views/Contacts.vue
// module id = 354
// module chunks = 0